import React, { useEffect } from "react";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import "./PasswordStep.scss";
import { useAppContext } from "../../context/AppContext";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import TextBody from "canvas-core-react/lib/TextBody";
import IconCongratulations from "../../assets/images/icon-congratulations.svg";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import { TitleCustom } from "../../components/TitleCustom/TitleCustom";
import ContinueButton from "canvas-core-react/lib/ContinueButton";
import { WealthService } from "../../../src/services/";
import { setActivaUrl } from "../../utils/set-activa-url";
import { RetryErrorComponent } from "../../components";

const PasswordStep = () => {
  const {
    state: context,
    changeItem: setContext,
    displayError,
  } = useAppContext();

  const wealthService = new WealthService();

  const getCookie = () => {
    const key = context.subjectId || null;
    setContext({ loading: true });
    wealthService
      .createActivaCookie(key)
      .then(() => {
        setContext({ loading: false });
      })
      .catch((error) => {
        displayError(
          error,
          getCookie,
          <RetryErrorComponent retryCallBack={getCookie} />
        );
      })
      .finally(() => {
        setContext({ loading: false });
      });
  };

  useEffect(() => {
    getCookie();
    // eslint-disable-next-line
  }, []);

  const ACTIVA_URL = setActivaUrl(window.location.hostname);

  const handleContinueClick = () => (window.location.href = ACTIVA_URL);

  return (
    <Grid className={"password-step"}>
      <Row>
        <Column xs={4} sm={8} md={8} mdOffset={2} lg={8} lgOffset={2}>
          <Row>
            <Column>
              <Margin xs={24} sm={24} md={24} lg={24}>
                <div className={"align-items--center"}>
                  <img src={IconCongratulations} alt="icon-congratulations" />
                </div>
              </Margin>
            </Column>
          </Row>
          <Row>
            <Column>
              <Margin
                xs={[0, 0, 24, 0]}
                sm={[0, 0, 24, 0]}
                md={[0, 0, 24, 0]}
                lg={[0, 0, 24, 0]}
              >
                <TitleCustom text="¡Felicitaciones! Tu cuenta corriente Wealth ha sido creada!" />
              </Margin>
            </Column>
          </Row>
          <Row>
            <Column>
              <Margin
                xs={[0, 0, 24, 0]}
                sm={[0, 0, 24, 0]}
                md={[0, 0, 24, 0]}
                lg={[0, 0, 24, 0]}
              >
                <TextSubtitle
                  component="p"
                  type="2"
                  className={"align-items--center"}
                >
                  {context.subjectData.name}
                </TextSubtitle>
                <TextBody
                  component="p"
                  type="2"
                  className={"align-items--center"}
                >
                  Su cuenta ha sido creada. Ahora te invitamos a crear tu clave
                  de ingreso.
                </TextBody>
              </Margin>
            </Column>
          </Row>
          <Row>
            <Column>
              <Margin
                xs={[0, 0, 24, 0]}
                sm={[0, 0, 24, 0]}
                md={[0, 0, 24, 0]}
                lg={[0, 0, 24, 0]}
              >
                <TextBody
                  component="p"
                  type="2"
                  className={"align-items--center"}
                >Dentro de 48 horas serás contactado por su ejecutivo para coordinar la entrega de tus tarjetas. Haz tus primeras transferencias desde tu celular activando tus accesos a{" "}
                  <TextSubtitle component="span" type="2">
                    Scotiabank GO
                  </TextSubtitle>{" "}
                  y{" "}
                  <TextSubtitle component="span" type="2">
                    Keypass
                  </TextSubtitle>
                  .
                </TextBody>
              </Margin>
            </Column>
          </Row>
          <Row>
            <Column xs={4} sm={8} md={4} mdOffset={8} lg={4} lgOffset={8}>
              <Margin
                xs={[0, 0, 24, 0]}
                sm={[0, 0, 24, 0]}
                md={[0, 0, 24, 0]}
                lg={[0, 0, 24, 0]}
              >
                <div className="buttons-mobile align-items--end">
                  <PrimaryButton
                    id="button-next-step"
                    onClick={handleContinueClick}
                  >
                    Continuar activación
                  </PrimaryButton>
                </div>
                <div
                  id="button-next-step"
                  className="buttons-web align-items--end"
                >
                  <ContinueButton onClick={handleContinueClick}>
                    Continuar activación
                  </ContinueButton>
                </div>
              </Margin>
            </Column>
          </Row>
        </Column>
      </Row>
    </Grid>
  );
};

export default PasswordStep;
